// extracted by mini-css-extract-plugin
module.exports = {"providerButton":"login_providerButton__s8YcB","login":"login_login__NWe34"};